module.exports = __webpack_public_path__ + "img/il_mail_newpassword.ef8ae141.svg";